// @ts-ignore
import { hydraDataProvider } from '@api-platform/admin';
import { parseHydraDocumentation as baseParseHydraDocumentation } from '@api-platform/api-doc-parser';
import ssBaseParseHydraDocumentation  from './customParseHydraDocumentation';
// @ts-ignore
import { DataProvider as RADataProvider, GetListParams } from 'react-admin';
import customFetchHydra from './fetchHydra';
import { uniformParams } from '../utils/providers/dataprovider';
import { uniformFilter } from '../utils/providers/ssDataProvider';
import { SS_RESOURCE_LIST } from './resources';
import { getToken, getSSToken, getSSTokenSync } from '../utils/token';

const entrypoint = `${process.env.REACT_APP_API_ENTRYPOINT}`;
const ssEntrypoint = `${process.env.REACT_APP_API_SS_ENTRYPOINT}`;

const withAuthorizationHeaders = (options: { [key: string]: any } = {}, token: string | null) => {
    const headers =
        options.headers instanceof Headers
            ? new Headers(options.headers)
            : new Headers(options.headers && typeof options.headers === 'object' ? options.headers : undefined);

    if (token) {
        headers.set('Authorization', `Bearer ${token}`.trim());
    }

    return {
        ...options,
        headers,
    };
};

const fetchHydra = (url: string, options: { [key: string]: any } = {}) => {
    const token = getToken();
    const result = customFetchHydra(url, withAuthorizationHeaders(options, token));

    return Promise.resolve(result).catch((e: any) => Promise.reject(e));
};

const ssFetchHydra = async (url: string, options: { [key: string]: any } = {}) => {
    const token = (await getSSToken()) || getToken();
    const result = customFetchHydra(url, withAuthorizationHeaders(options, token));

    return Promise.resolve(result).catch((e: any) => Promise.reject(e));
};

const parseHydraDocumentation = (url: string, options: RequestInit = {}) => {
    return baseParseHydraDocumentation(url, {
        ...options,
        headers: () => {
            const token = getToken();
            return withAuthorizationHeaders({}, token).headers;
        },
    });
};

const ssParseHydraDocumentation = (url: string, options: RequestInit = {}) => {
    return ssBaseParseHydraDocumentation(url, {
        ...options,
        headers: () => {
            const token = getSSTokenSync() || getToken();
            return withAuthorizationHeaders({}, token).headers;
        },
    });
};

const dataProvider = hydraDataProvider(
    entrypoint,
    fetchHydra,
    parseHydraDocumentation,
    true // useEmbedded parameter
);

const ssDataProvider = hydraDataProvider(
    ssEntrypoint,
    ssFetchHydra,
    ssParseHydraDocumentation,
    true // useEmbedded parameter
);

export type DataProvider = RADataProvider & {
    introspect: (_resource: string) => Promise<{ data: any }[]>;
};

const PatchGetListDataProvider: DataProvider = {
    ...dataProvider,
    // ...ssDataProvider,
    getList: (resource: string, params: GetListParams) => {
        const customFilters = uniformParams(params.filter ? params.filter : {});

        if (SS_RESOURCE_LIST.includes(resource)) {
            const filters = uniformFilter(params.filter);
            return ssDataProvider.getList(resource, {
                ...params,
                filter: {
                    ...customFilters,
                    ...filters,
                },
            });
        }

        return dataProvider.getList(resource, {
            ...params,
            filter: {
                ...customFilters,
            },
        });
    },
    introspect: (_resource: string) => {
        return Promise.all([ssDataProvider.introspect(_resource), dataProvider.introspect(_resource)]);
    },
};

export default PatchGetListDataProvider;
